// Lightweight Meta (Facebook) Pixel helper.
// - initMetaPixel(): injects the fbq snippet once and fires the initial PageView.
// - trackAddToCart(): fires an AddToCart event (call right before redirecting
//   the user to the Shopify cart).

const PIXEL_ID = '841654192074270'

declare global {
  interface Window {
    fbq?: (...args: any[]) => void
    _fbq?: unknown
  }
}

let initialized = false

export function initMetaPixel() {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  try {
    const f = window as any
    if (!f.fbq) {
      // Named function expression: its own name is safely in scope inside the
      // body (no temporal-dead-zone / block-scoping pitfalls).
      const n: any = function fbq(...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args)
      }
      f.fbq = n
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []

      const t = document.createElement('script')
      t.async = true
      t.src = 'https://connect.facebook.net/en_US/fbevents.js'
      const s = document.getElementsByTagName('script')[0]
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s)
      } else {
        document.head.appendChild(t)
      }
    }

    f.fbq('init', PIXEL_ID)
    f.fbq('track', 'PageView')
  } catch (err) {
    // Never let analytics break the page render.
    console.error('Meta Pixel init failed:', err)
  }
}

interface AddToCartParams {
  value?: number
  contents?: { id: string; quantity: number }[]
}

export function trackAddToCart(params: AddToCartParams = {}) {
  if (typeof window === 'undefined' || !window.fbq) return
  try {
    window.fbq('track', 'AddToCart', {
      currency: 'ARS',
      value: params.value,
      content_type: 'product',
      contents: params.contents,
      content_ids: params.contents?.map((c) => c.id),
    })
  } catch (err) {
    console.error('Meta Pixel AddToCart failed:', err)
  }
}
